import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ArpioSharedModule } from '../../shared/arpio-shared.module'

import { ArpioAlertRoutingModule } from './arpio-alert-routing.module'
import { ArpioAlertComponent } from './components/arp-alert/arpio-alert.component'
import { AlertsEditorComponent } from './components/alerts-editor/alerts-editor.component'

import { FluidModule } from 'primeng/fluid'

@NgModule({
  declarations: [ArpioAlertComponent, AlertsEditorComponent],
  imports: [CommonModule, ArpioSharedModule, ArpioAlertRoutingModule, FormsModule, ReactiveFormsModule, FluidModule],
})
export class ArpioAlertModule {}
